import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { PermissionRequirement } from '@/interfaces/permission.interface';
import { useAuthStore } from '@/modules/Login/store';

interface PermissionGuardProps {
	children: ReactNode;
	requiredPermissions?: PermissionRequirement;
}

export const PermissionGuard = ({ children, requiredPermissions }: PermissionGuardProps) => {
	const hasPermission = useAuthStore(state => state.hasPermission);
	const user = useAuthStore(state => state.user);
	const isAuthenticating = useAuthStore(state => state.isAuthenticating);

	if (!requiredPermissions) {
		return <>{children}</>;
	}

	if (!user && !isAuthenticating) {
		return <Navigate to="/login" replace />;
	}

	if (!isAuthenticating && !hasPermission(requiredPermissions)) {
		return <Navigate to="/not-found" replace />;
	}

	return <>{children}</>;
};

interface SessionGuardProps {
	children: ReactNode;
}

export const SessionGuard = ({ children }: SessionGuardProps) => {
	const user = useAuthStore(state => state.user);
	const isAuthenticating = useAuthStore(state => state.isAuthenticating);

	if (!user && !isAuthenticating) {
		return <Navigate to="/login" replace />;
	}

	return <>{children}</>;
};
